export enum ArchiveMethods {
  POST_ARCHIVE = 'post_archive_oca_address' as any
}
